export default function Drone(props: any) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9728_20413)">
                <path
                    d="M10.1875 10.1841L14.7467 14.7433M25.8191 25.8156L21.2599 21.2564"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.8191 10.1841L21.2599 14.7433M10.1875 25.8156L14.7467 21.2564"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path d="M21.2553 14.7437H14.7422V21.2568H21.2553V14.7437Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M25.817 14.7434C26.7188 14.7434 27.6002 14.476 28.35 13.9751C29.0997 13.4741 29.6841 12.762 30.0292 11.9289C30.3743 11.0959 30.4645 10.1791 30.2886 9.29477C30.1127 8.41035 29.6785 7.59798 29.0408 6.96037C28.4033 6.32275 27.5909 5.88852 26.7065 5.71261C25.8221 5.53669 24.9054 5.62697 24.0723 5.97205C23.2392 6.31713 22.5272 6.90149 22.0262 7.65125C21.5252 8.401 21.2578 9.28246 21.2578 10.1842"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.817 21.2563C26.7188 21.2563 27.6002 21.5237 28.35 22.0247C29.0997 22.5257 29.6841 23.2377 30.0292 24.0708C30.3743 24.9039 30.4645 25.8206 30.2886 26.705C30.1127 27.5894 29.6785 28.4018 29.0408 29.0394C28.4033 29.677 27.5909 30.1112 26.7065 30.2872C25.8221 30.4631 24.9054 30.3728 24.0723 30.0277C23.2392 29.6826 22.5272 29.0982 22.0262 28.3485C21.5252 27.5987 21.2578 26.7173 21.2578 25.8156"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.1842 21.2563C9.28246 21.2563 8.40101 21.5237 7.65125 22.0247C6.90149 22.5257 6.31713 23.2377 5.97205 24.0708C5.62697 24.9039 5.53669 25.8206 5.71261 26.705C5.88852 27.5894 6.32275 28.4018 6.96037 29.0394C7.59798 29.677 8.41035 30.1112 9.29477 30.2872C10.1791 30.4631 11.0959 30.3728 11.9289 30.0277C12.762 29.6826 13.4741 29.0982 13.9751 28.3485C14.476 27.5987 14.7434 26.7173 14.7434 25.8156"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.1842 14.7434C9.28246 14.7434 8.40101 14.476 7.65125 13.9751C6.90149 13.4741 6.31713 12.762 5.97205 11.9289C5.62697 11.0959 5.53669 10.1791 5.71261 9.29477C5.88852 8.41035 6.32275 7.59798 6.96037 6.96037C7.59798 6.32275 8.41035 5.88852 9.29477 5.71261C10.1791 5.53669 11.0959 5.62697 11.9289 5.97205C12.762 6.31713 13.4741 6.90149 13.9751 7.65125C14.476 8.401 14.7434 9.28246 14.7434 10.1842"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_9728_20413">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
